module.exports = __webpack_public_path__ + "img/banner-02.7031cf27.jpg";